/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { CardType } from './CardType';
import {
    CardTypeFromJSON,
    CardTypeFromJSONTyped,
    CardTypeToJSON,
} from './CardType';
import type { SAPPaymentMethod } from './SAPPaymentMethod';
import {
    SAPPaymentMethodFromJSON,
    SAPPaymentMethodFromJSONTyped,
    SAPPaymentMethodToJSON,
} from './SAPPaymentMethod';

/**
 * Payment details object
 * @export
 * @interface PaymentDetails
 */
export interface PaymentDetails {
    /**
     * Unique identifier of payment detail
     * @type {string}
     * @memberof PaymentDetails
     */
    id?: string;
    /**
     * Name of account holder
     * @type {string}
     * @memberof PaymentDetails
     */
    accountHolderName?: string;
    /**
     * 
     * @type {CardType}
     * @memberof PaymentDetails
     */
    cardType?: CardType;
    /**
     * Payment card number
     * @type {string}
     * @memberof PaymentDetails
     */
    cardNumber?: string;
    /**
     * Start month from which payment is valid
     * @type {string}
     * @memberof PaymentDetails
     */
    startMonth?: string;
    /**
     * Start year from which payment is valid
     * @type {string}
     * @memberof PaymentDetails
     */
    startYear?: string;
    /**
     * Month of expiration of payment
     * @type {string}
     * @memberof PaymentDetails
     */
    expiryMonth?: string;
    /**
     * Year of expiration of payment
     * @type {string}
     * @memberof PaymentDetails
     */
    expiryYear?: string;
    /**
     * Issue number
     * @type {string}
     * @memberof PaymentDetails
     */
    issueNumber?: string;
    /**
     * Identifier of subscription
     * @type {string}
     * @memberof PaymentDetails
     */
    subscriptionId?: string;
    /**
     * Flag to mark if payment is saved one
     * @type {boolean}
     * @memberof PaymentDetails
     */
    saved?: boolean;
    /**
     * Flag to mark if payment the default one
     * @type {boolean}
     * @memberof PaymentDetails
     */
    defaultPayment?: boolean;
    /**
     * 
     * @type {Address}
     * @memberof PaymentDetails
     */
    billingAddress?: Address;
    /**
     * 
     * @type {SAPPaymentMethod}
     * @memberof PaymentDetails
     */
    sapPaymentMethod?: SAPPaymentMethod;
}

/**
 * Check if a given object implements the PaymentDetails interface.
 */
export function instanceOfPaymentDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaymentDetailsFromJSON(json: any): PaymentDetails {
    return PaymentDetailsFromJSONTyped(json, false);
}

export function PaymentDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'accountHolderName': !exists(json, 'accountHolderName') ? undefined : json['accountHolderName'],
        'cardType': !exists(json, 'cardType') ? undefined : CardTypeFromJSON(json['cardType']),
        'cardNumber': !exists(json, 'cardNumber') ? undefined : json['cardNumber'],
        'startMonth': !exists(json, 'startMonth') ? undefined : json['startMonth'],
        'startYear': !exists(json, 'startYear') ? undefined : json['startYear'],
        'expiryMonth': !exists(json, 'expiryMonth') ? undefined : json['expiryMonth'],
        'expiryYear': !exists(json, 'expiryYear') ? undefined : json['expiryYear'],
        'issueNumber': !exists(json, 'issueNumber') ? undefined : json['issueNumber'],
        'subscriptionId': !exists(json, 'subscriptionId') ? undefined : json['subscriptionId'],
        'saved': !exists(json, 'saved') ? undefined : json['saved'],
        'defaultPayment': !exists(json, 'defaultPayment') ? undefined : json['defaultPayment'],
        'billingAddress': !exists(json, 'billingAddress') ? undefined : AddressFromJSON(json['billingAddress']),
        'sapPaymentMethod': !exists(json, 'sapPaymentMethod') ? undefined : SAPPaymentMethodFromJSON(json['sapPaymentMethod']),
    };
}

export function PaymentDetailsToJSON(value?: PaymentDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'accountHolderName': value.accountHolderName,
        'cardType': CardTypeToJSON(value.cardType),
        'cardNumber': value.cardNumber,
        'startMonth': value.startMonth,
        'startYear': value.startYear,
        'expiryMonth': value.expiryMonth,
        'expiryYear': value.expiryYear,
        'issueNumber': value.issueNumber,
        'subscriptionId': value.subscriptionId,
        'saved': value.saved,
        'defaultPayment': value.defaultPayment,
        'billingAddress': AddressToJSON(value.billingAddress),
        'sapPaymentMethod': SAPPaymentMethodToJSON(value.sapPaymentMethod),
    };
}

